export default __webpack_public_path__ + "static/media/Benefits3.476b89a5.bin";